/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_ClosedInputs */

const en_us2_group_closed = /** @type {(inputs: Group_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This group was closed.`)
};

const pt_br2_group_closed = /** @type {(inputs: Group_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta turma foi encerrada.`)
};

const pt_pt2_group_closed = /** @type {(inputs: Group_ClosedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta turma foi encerrada.`)
};

/** @type {(inputs: Group_ClosedInputs) => LocalizedString} */
const es_419_group_closed = en_us2_group_closed;

/** @type {(inputs: Group_ClosedInputs) => LocalizedString} */
const fr_fr2_group_closed = en_us2_group_closed;

/** @type {(inputs: Group_ClosedInputs) => LocalizedString} */
const de_de2_group_closed = en_us2_group_closed;

/** @type {(inputs: Group_ClosedInputs) => LocalizedString} */
const it_it2_group_closed = en_us2_group_closed;

/**
* | output |
* | --- |
* | "This group was closed." |
*
* @param {Group_ClosedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_closed = /** @type {((inputs?: Group_ClosedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_ClosedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_closed(inputs)
	if (locale === "es-419") return es_419_group_closed(inputs)
	if (locale === "pt-PT") return pt_pt2_group_closed(inputs)
	if (locale === "fr-FR") return fr_fr2_group_closed(inputs)
	if (locale === "de-DE") return de_de2_group_closed(inputs)
	if (locale === "it-IT") return it_it2_group_closed(inputs)
	return en_us2_group_closed(inputs)
});
export { group_closed as "group.closed" }